import {createSlice} from '@reduxjs/toolkit'

const siteMapsSlice = createSlice({
    name:'siteMaps',
    initialState: {
        data: null,
        status: 'idle',
        error: null,

        pannelloDiControllo: false,
        metodologia: false,
        compilazioneDatigeneraliQuestionario: false,
        compilazioneAmbitiSelezionati: false,
        output: false,

        test: 'OK-OK',
        testValue: 0,
    },
    reducers: {

        setPartnerMenu: () => {
//            state.pannelloDiControllo = true,
//            state.metodologia = true,
//            state.compilazioneDatigeneraliQuestionario = false,
//            state.compilazioneAmbitiSelezionati = false,
//            state.output = false
        },
        setAziendaMenu: () => {
//            state.metodologia = true,
//            state.compilazioneDatigeneraliQuestionario = false,
//            state.compilazioneAmbitiSelezionati = false,
//            state.output = false
        },
        setQuestionarioMenu: () => {
//            state.compilazioneDatigeneraliQuestionario = true,
//            state.compilazioneAmbitiSelezionati = true,
//            state.output = true
        },
        unsetQuestionarioMenu: () => {
//            state.compilazioneDatigeneraliQuestionario = false,
//            state.compilazioneAmbitiSelezionati = false,
//            state.output = false
        }

    }
})

export const { setPartnerMenu, setAziendaMenu, setQuestionarioMenu, unsetQuestionarioMenu } = siteMapsSlice.actions

export const siteMapsReducer = siteMapsSlice.reducer

/*
        setPartnerMenu: (state) => {
//            state.pannelloDiControllo = true,
//            state.metodologia = true,
//            state.compilazioneDatigeneraliQuestionario = false,
//            state.compilazioneAmbitiSelezionati = false,
//            state.output = false
        },
        setAziendaMenu: (state) => {
//            state.metodologia = true,
//            state.compilazioneDatigeneraliQuestionario = false,
//            state.compilazioneAmbitiSelezionati = false,
//            state.output = false
        },
        setQuestionarioMenu: (state) => {
//            state.compilazioneDatigeneraliQuestionario = true,
//            state.compilazioneAmbitiSelezionati = true,
//            state.output = true
        },
        unsetQuestionarioMenu: (state) => {
//            state.compilazioneDatigeneraliQuestionario = false,
//            state.compilazioneAmbitiSelezionati = false,
//            state.output = false
        }
*/
